import httpService from "./httpService";
import utils from "./utils";

export default {
    findById(id) {
        return httpService.get("news/" + id, null);
    },

    // Lấy danh sách tin tức
    getListNews(usingAdvanceSearch, keyword, form, pageable) {
        let params = utils.merge({
            advanceSearch: usingAdvanceSearch ? true : null,
            keyword
        }, pageable);
        return httpService.post("news/search", usingAdvanceSearch ? { ...form, title: keyword } : {}, { params });
    },

    // Thêm mới tin tức
    save(form) {
        return httpService.post(`news`, form);
    },

    // Sửa tin tức
    update(id, form) {
        return httpService.put(`/news/${id}`, form);
    },

    // Xóa tin tức
    delete(id) {
        return httpService.delete(`news/${id}`);
    },

    // Xóa nhiều tin tức
    deleteMulti(listNews) {
        let form = {
            ids: listNews
        }
        return httpService.post(`news/delete`, form);
    },
}



// WEBPACK FOOTER //
// ./src/services/newsService.js